import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AdminAuthContext } from "../context/AdminAuthContext";
import { Logo, GhostButton, ThemeToggle } from "../../design-system";
import { typography, surfaces, borders, textColors, brandColors } from "../../design-system/tokens";

const AdminNavbar = () => {
  const { adminAuth, adminLogout } = useContext(AdminAuthContext);

  return (
    <nav className={`sticky top-0 z-50 ${surfaces.glass} shadow-sm border-b ${borders.glass}`}>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left: Logo */}
          <div className="flex items-center space-x-4">
            <Link to="/admin/dashboard/dashboard" className="flex items-center">
              <Logo 
                iconSize="w-8 h-8" 
                textSize="text-2xl" 
                useCurrentColor={false}
                iconColor="#3b82f6"
                textColor={brandColors.gradientText}
              />
            </Link>
            <h1 className={`${typography.h4} ${textColors.primary} hidden sm:block`}>
              Admin Dashboard
            </h1>
          </div>

          {/* Right: Theme Toggle, Username and Logout */}
          <div className="flex items-center space-x-4">
            {/* Theme Toggle */}
            <ThemeToggle />
            
            {adminAuth.username && (
              <span className={`${typography.body} ${textColors.secondary} hidden sm:block`}>
                {adminAuth.username}
              </span>
            )}
            <GhostButton
              onClick={adminLogout}
              variant="neutral"
              size="sm"
              className={typography.bodySmall}
            >
              Logout
            </GhostButton>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;

